import { useBondsListTransformApi } from '../api';
import { mapSAccId } from '../../../../shared';

export const useBondListSAccIds = () => {
  const response = useBondsListTransformApi({
    transformFunction: mapSAccId,
  });
  return response;
};
